<script>
    import {
        ButtonGroup,
        Card,
        CardHeader,
        CardTitle,
        CardText,
        CardSubtitle,
        CardBody,
        Accordion,
        AccordionItem,
        Button,
    } from "@sveltestrap/sveltestrap";

    export let j;
    export let n;
    export let season;
    export let clsPrevSeason;
    export let classifs;
    export let modesclassif;
    // export let modes
    // export let modesMatchs
    export let res;
    export let resMatchs;
    export let adv;
    export let Ind;
    export let eq;
    export let msByMode;

    let dimens = "col-xxl-3 col-xl-5 col-lg-6 col-sm-10 col-md-7 col-12";
    let clsmsg = clsPrevSeason ? "(juillet " + (season - 1) + ")" : "(juillet " + (season) + ")";
    // console.log('summary')
    // console.log(clsPrevSeason)
</script>

<div class="row">
    <div class={dimens}>
        <h3 class="titlesHighlight">{j} - {season -1}/{season}</h3>
    </div>
</div>
<br />
<div class="row">
    <div class={dimens}>
        <h3 class="titles">Résumé</h3>
    </div>
</div>
<div class="row">
    <div class={dimens}>
        <table class="table table-sm">
            <thead>
                <tr>
                    <th scope="col" style="text-align:center"> Matchs </th>
                    <th scope="col" style="text-align:center">
                        <span class="badge" style="background-color:red">G</span
                        >
                    </th>
                    <th scope="col" style="text-align:center">
                        <span class="badge" style="background-color:blue"
                            >P</span
                        >
                    </th>
                    <th scope="col" style="text-align:center">
                        <span class="badge" style="background-color:lightgreen"
                            >N</span
                        >
                    </th>
                    <th scope="col" style="text-align:center"> Adv. </th>
                    <th scope="col" style="text-align:center"> Indiv. </th>
                    <th scope="col" style="text-align:center"> Equipe </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="text-align:center">{n}</td>
                    {#each res as r}
                        <td style="text-align:center">{resMatchs[r]}</td>
                    {/each}
                    <td style="text-align:center">{adv}</td>
                    <td style="text-align:center">{Ind}</td>
                    <td style="text-align:center">{eq}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<br />
<div class="row">
    <div class={dimens}>
        <h3 class="titles">Classifications {clsmsg}</h3>
    </div>
</div>
<div class="row">
    <div class={dimens}>
        <table class="table table-sm">
            <thead>
                <tr>
                    <th scope="col" style="text-align:start"> Spécialité </th>
                    <th scope="col" style="text-align:center"> Catég. </th>
                    <th scope="col" style="text-align:center">
                        <i class="bi bi-star-fill"></i>
                    </th>
                    <th scope="col" style="text-align:center"> MG </th>
                    <th scope="col" style="text-align:center"> MS </th>
                    <th scope="col" style="text-align:center"> Matchs </th>
                </tr>
            </thead>
            <tbody>
                {#each modesclassif as md}
                    <tr>
                        {#if classifs[md][7] > 0}
                            <td style="text-align:start">{md}</td>
                            <td style="text-align:center">{classifs[md][3]}</td>
                            <td style="text-align:center">
                                {#if classifs[md][4] == 1}
                                    <i class="bi bi-star-fill"></i>
                                {/if}
                            </td>
                            <td style="text-align:center">{classifs[md][9]}</td>
                            {#if !clsPrevSeason}
                                {#if msByMode[md]==undefined}
                                    <td style="text-align:end">-</td>
                                {:else}
                                    <td style="text-align:end">{msByMode[md]}</td>
                                {/if}
                            {:else}
                                <td style="text-align:end">-</td>
                            {/if}
                            <td style="text-align:center">{classifs[md][7]}</td>
                        {:else}
                            <td style="text-align:start;font-style: italic;"
                                >{md}</td
                            >
                            <td style="text-align:center;font-style: italic;"
                                >{classifs[md][3]}</td
                            >
                            <td style="text-align:center">
                                {#if classifs[md][4] == 1}
                                    <i class="bi bi-star-fill"></i>
                                {/if}
                            </td>
                            <td style="text-align:center;font-style: italic;"
                                >{classifs[md][9]}</td
                            >
                            <td style="text-align:end;font-style: italic;">-</td
                            >
                            <td style="text-align:center;font-style: italic;"
                                >({classifs[md][8]})</td
                            >
                        {/if}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>

<style>
    .titles {
        text-align: center;
        font-size: 1.2em;
        font-weight: bold;
    }
    .titlesHighlight {
        background-color: lightblue;
        padding: 4px;
        text-align: center;
        font-size: 1.2em;
        font-weight: bold;
        border-radius: 8px;
    }
</style>
